import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function PropertyManagement(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(
    SvgIcon,
    {
      ...rest,
      "data-tidal": "TidalIllustration",
      "data-tidal-illustration": "PropertyManagement",
      sx,
      viewBox,
      children: [
        /* @__PURE__ */ jsx("path", { d: "M35.492 12.083H13.969v23.834h21.523V12.082Z", fill: theme.vars.palette.primary.light }),
        /* @__PURE__ */ jsx("path", { d: "M13.969 13h21.523v-.917L24.73 4.75l-10.76 7.333V13Z", fill: theme.vars.palette.primary.light }),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m11.517 14.833 13.213-8.25 13.212 8.25 2.033-2.75L24.73 2 9.484 12.083l2.033 2.75ZM31.903 18.5H17.555v15.583h14.348V18.5Z",
            fill: theme.vars.palette.primary.dark
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M42.017 26.826a2.699 2.699 0 0 0-1.21-.014c-.4.087-.775.263-1.1.516l-8.945 7.09a6.652 6.652 0 0 1-2.894 1.318v-2.055a2.719 2.719 0 0 0-.552-1.619 2.62 2.62 0 0 0-1.398-.946l-4.816-1.361a6.817 6.817 0 0 0-5.071.557l-7.668 4.215v9.411l7.032-1.394h13.257a6.647 6.647 0 0 0 4.611-1.87l9.975-9.602c.326-.315.561-.715.678-1.158a2.534 2.534 0 0 0-.014-1.348 2.49 2.49 0 0 0-.702-1.142 2.408 2.408 0 0 0-1.183-.598Z",
            fill: theme.vars.palette.secondary.main
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M27.868 34.34v1.395a6.736 6.736 0 0 1-1.237.11 7.44 7.44 0 0 1-1.238-.103l-5.044-.886a.675.675 0 0 1-.438-.283.703.703 0 0 1 .162-.963.664.664 0 0 1 .504-.117l5.045.888a5.874 5.874 0 0 0 2.246-.041Z",
            fill: theme.vars.palette.primary.light
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "m5 46 5.38-.558c.368-.022.713-.187.964-.463.25-.275.388-.64.382-1.015l-.585-10.375a1.548 1.548 0 0 0-.207-.616 1.513 1.513 0 0 0-.44-.472 1.475 1.475 0 0 0-1.23-.208L5 33.29V46Z",
            fill: theme.vars.palette.primary.light
          }
        )
      ]
    }
  );
}
PropertyManagement.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "PropertyManagement"
};
validateTidalLicense();
export {
  PropertyManagement
};
//# sourceMappingURL=PropertyManagement.js.map
